/**
 * Pagination "Voir plus" pour la liste des actualités
 * Lit les articles depuis data-articles sur #news-grid et les affiche par tranches de 16
 */
export const initNewsPagination = (): void => {
    const grid = document.getElementById('news-grid') as HTMLElement;
    const btn = document.getElementById('news-load-more') as HTMLElement;

    if (!grid || !btn) return;

    const articlesJson = grid.dataset.articles;
    if (!articlesJson) return;

    const allArticles: any[] = JSON.parse(articlesJson);
    const locale = grid.dataset.locale || 'fr';
    let offset = 0;
    const perPage = 16;

    btn.addEventListener('click', () => {
        const batch = allArticles.slice(offset, offset + perPage);
        batch.forEach((a: any) => {
            // en-us = M D, Y via Intl, on force en-gb pour garder l'ordre D M Y
            // aligné avec le rendu Blade (isoFormat('D MMM YYYY'))
            const dateLocale = locale === 'en-us' ? 'en-gb' : locale;
            const dateStr = a.published_at
                ? new Date(a.published_at).toLocaleDateString(dateLocale, { day: 'numeric', month: 'short', year: 'numeric' })
                : '';
            const link = document.createElement('a');
            link.href = '/' + locale + '/news/' + a.slug;
            link.className = 'block h-full';
            link.setAttribute('data-gsap', 'news-latest-item');
            link.innerHTML =
                '<div class="h-full flex flex-col border-b border-(--color-quaternary) pb-[9px]">' +
                    '<div class="flex justify-between mb-1">' +
                        '<span class="font-sans-variant font-medium text-base text-(--color-quaternary)">' + dateStr + '</span>' +
                        '<span class="font-sans-variant font-medium text-base text-(--color-quaternary)">' + (a.type || '') + '</span>' +
                    '</div>' +
                    '<div class="font-sans-variant text-pretitle text-secondary-950 mb-auto">' + a.name + '</div>' +
                '</div>';
            grid.appendChild(link);
        });

        offset += perPage;
        if (offset >= allArticles.length) {
            btn.style.display = 'none';
        }
    });
}
